// Live room membership over the core socket. Joins wait for the socket to
// exist and connect (it opens shortly after login), and rooms are re-joined
// automatically after reconnects.
const SOCKET_WAIT_MS = 15000
const ACK_TIMEOUT_MS = 10000

const rejoinHandlers = new WeakMap()

// Accepts a Vuex action context or the root store.
const coreSocket = (store) => (store.rootState || store.state)?.io?._io?.core || null

const waitForSocket = async (store) => {
  const started = Date.now()
  while (Date.now() - started < SOCKET_WAIT_MS) {
    const socket = coreSocket(store)
    if (socket?.connected) return socket
    await new Promise((resolve) => setTimeout(resolve, 250))
  }
  return null
}

const roomKey = (room) => (room.room === 'stream' ? `stream:${room.streamId}` : room.room)

const ensureRejoin = (socket) => {
  if (rejoinHandlers.has(socket)) return rejoinHandlers.get(socket)
  const rooms = new Map()
  socket.on('connect', () => {
    rooms.forEach(({ room, onAck }) => {
      socket
        .timeout(ACK_TIMEOUT_MS)
        .emitWithAck('live:join', room)
        .then((ack) => ack?.success && onAck?.(ack))
        .catch((err) => console.warn('live rejoin failed', roomKey(room), err))
    })
  })
  rejoinHandlers.set(socket, rooms)
  return rooms
}

export const joinLiveRoom = async (store, room, onAck) => {
  const socket = await waitForSocket(store)
  if (!socket) return { success: false, error: 'NO_SOCKET' }
  ensureRejoin(socket).set(roomKey(room), { room, onAck })
  try {
    const ack = await socket.timeout(ACK_TIMEOUT_MS).emitWithAck('live:join', room)
    if (ack?.success) onAck?.(ack)
    return ack
  } catch (err) {
    console.warn('live join failed', roomKey(room), err)
    return { success: false, error: 'JOIN_FAILED' }
  }
}

export const leaveLiveRoom = async (store, room) => {
  const socket = coreSocket(store)
  if (!socket) return
  rejoinHandlers.get(socket)?.delete(roomKey(room))
  if (socket.connected) socket.emit('live:leave', room)
}
